<template>
	<el-container class="home-container">
		<el-header class="header">
			<div class="header-left">
				<div class="logo-wrapper">
					<img class="logo-img" src="../assets/image/logo.png" alt="" />
					<span class="logo-text">智能锁管理平台</span>
				</div>
				<div class="toggle-btn" @click="toggleCollapse">
					<i :class="isCollpase ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
				</div>
			</div>
			<div class="header-right">
				<div class="distributor-switch" v-if="distributorSwitchList.length > 0">
					<el-select 
						v-model="currentDistributorId" 
						placeholder="切换运营商" 
						size="small"
						@change="handleDistributorChange"
						clearable
						filterable
						class="distributor-select">
						<el-option v-if="isAdmin" label="全部运营商" value="">
							<span style="float: left">全部运营商</span>
						</el-option>
						<el-option 
							v-for="item in distributorSwitchList" 
							:key="item.id" 
							:label="item.name" 
							:value="item.id">
							<span style="float: left">{{ item.name }}</span>
							<span style="float: right; color: #8492a6; font-size: 12px">
								<el-tag v-if="item.level === 1" type="success" size="mini">一级</el-tag>
								<el-tag v-else-if="item.level === 2" type="warning" size="mini">二级</el-tag>
								<el-tag v-else-if="item.level === 3" type="info" size="mini">三级</el-tag>
							</span>
						</el-option>
					</el-select>
				</div>
				<div class="header-actions">
					<div class="action-item" @click="toggleFullScreen()">
						<i :class="isFullscreen ? 'el-icon-crop' : 'el-icon-full-screen'"></i>
					</div>
					<el-dropdown trigger="click" @command="handleCommand" class="user-dropdown">
						<div class="user-info">
							<img class="avatar" src="../assets/image/head.png" />
							<span class="username">{{ nickName }}</span>
							<i class="el-icon-arrow-down"></i>
						</div>
						<el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
							<el-dropdown-item command="1">
								<i class="el-icon-user"></i> 个人账号
							</el-dropdown-item>
							<el-dropdown-item command="2" divided>
								<i class="el-icon-switch-button"></i> 退出登录
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</el-header>
		<el-container class="main-container">
			<el-aside :width="isCollpase ? '64px' : '220px'" class="aside">
				<el-scrollbar class="aside-scrollbar">
					<el-menu 
						class="aside-menu"
						:unique-opened="true" 
						:collapse="isCollpase" 
						:collapse-transition="false" 
						router
						:default-active="activePath">
						<el-menu-item index="/welcome" @click="saveNavState('/welcome')">
							<i class="el-icon-s-home"></i>
							<span slot="title">首页</span>
						</el-menu-item>
						<el-submenu v-for="item in menulist" :key="item.id" :index="item.id + ''">
							<template slot="title">
								<i :class="item.menuIcon"></i>
								<span>{{ item.menuName }}</span>
							</template>
							<el-menu-item 
								v-for="subItem in item.subMenus" 
								:key="subItem.id"
								:index="'/' + subItem.menuUrl" 
								@click="saveNavState('/' + subItem.menuUrl)">
								<span>{{ subItem.menuName }}</span>
							</el-menu-item>
						</el-submenu>
					</el-menu>
				</el-scrollbar>
			</el-aside>
			<el-main class="main-content">
				<TabsBar @refresh="refreshPage" />
				<div class="page-wrapper">
					<transition name="fade-transform" mode="out-in">
						<router-view :key="componentKey" v-if="show" class="page-content"></router-view>
					</transition>
				</div>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
import screenfull from "screenfull";
import TabsBar from "@/components/TabsBar.vue";

export default {
	components: {
		TabsBar
	},
	data() {
		return {
			show: true,
			componentKey: 0,
			isFullscreen: false,
			menulist: [],
			isCollpase: false,
			activePath: '',
			nickName: '',
			distributorSwitchList: [],
			currentDistributorId: '',
			isAdmin: false
		}
	},
	mounted() {
		window.addEventListener('keydown', (event) => this.handleKeyDown(event));
		screenfull.on('change', () => {
			this.isFullscreen = screenfull.isFullscreen;
		});
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.handleKeyDown);
		screenfull.off('change');
	},
	created() {
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true'
		this.getMenuList()
		const currentPath = this.$route.path
		if (currentPath && currentPath !== '/home' && currentPath !== '/welcome') {
			this.activePath = currentPath
			window.sessionStorage.setItem('activePath', currentPath)
		} else {
			const storedPath = window.sessionStorage.getItem('activePath')
			this.activePath = storedPath || '/welcome'
		}
		this.nickName = window.sessionStorage.getItem('nickName') || '管理员'
		this.getDistributorSwitchList()
	},
	watch: {
		// 监听路由变化，实现标签页切换与左侧菜单选中状态的联动
		$route(to, from) {
			if (to.path && to.path !== '/home' && to.path !== '/welcome') {
				this.activePath = to.path
				window.sessionStorage.setItem('activePath', to.path)
			}
		}
	},
	methods: {
		handleKeyDown(event) {
			if (event.key === 'Escape') {
				this.isFullscreen = false;
			}
		},
		logout() {
			window.sessionStorage.clear()
			this.$router.push('/login')
		},
		async getMenuList() {
			const { data: res } = await this.$http.get('/system/authorities/menus')
			this.menulist = res.data
		},
		toggleCollapse() {
			this.isCollpase = !this.isCollpase
		},
		saveNavState(activePath) {
			window.sessionStorage.setItem('activePath', activePath)
			this.activePath = activePath
		},
		handleCommand(command) {
			if (command === '1') {
				this.$router.push('/my/myInfo')
			} else if (command === '2') {
				this.logout()
			}
		},
		toggleFullScreen() {
			if (screenfull.isEnabled) {
				screenfull.toggle();
			}
		},
		async getDistributorSwitchList() {
			try {
				const { data: res } = await this.$http.get('/distributor/manager/switchList')
				if (res.code === 200) {
					this.distributorSwitchList = res.data || []
					this.$nextTick(() => {
						const storedId = window.sessionStorage.getItem('currentDistributorId')
						if (storedId) {
							this.currentDistributorId = storedId
						} else if (!this.isAdmin && this.distributorSwitchList.length > 0) {
							this.currentDistributorId = this.distributorSwitchList[0].id
							window.sessionStorage.setItem('currentDistributorId', this.currentDistributorId)
							window.sessionStorage.setItem('currentDistributorName', this.distributorSwitchList[0].name)
						} else {
							this.currentDistributorId = ''
						}
					})
				}
			} catch (error) {
				console.error('获取运营商切换列表失败:', error)
			}
		},
		handleDistributorChange(val) {
			this.currentDistributorId = val || ''
			if (val) {
				window.sessionStorage.setItem('currentDistributorId', val)
				const selected = this.distributorSwitchList.find(item => item.id === val)
				if (selected) {
					window.sessionStorage.setItem('currentDistributorName', selected.name)
				}
			} else {
				window.sessionStorage.removeItem('currentDistributorId')
				window.sessionStorage.removeItem('currentDistributorName')
			}
			this.$root.$emit('distributorChanged', val)
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		},
		refreshPage() {
			this.componentKey += 1
		}
	},
}
</script>

<style scoped>
.home-container {
	height: 100vh;
	overflow: hidden;
}

.header {
	height: 56px !important;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 20px;
	background: linear-gradient(135deg, #3CA757 0%, #2d8a47 100%);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
}

.header-left {
	display: flex;
	align-items: center;
}

.logo-wrapper {
	display: flex;
	align-items: center;
	margin-right: 24px;
}

.logo-img {
	width: 36px;
	height: 36px;
	border-radius: 8px;
}

.logo-text {
	margin-left: 12px;
	font-size: 18px;
	font-weight: 600;
	color: #fff;
	letter-spacing: 1px;
}

.toggle-btn {
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 8px;
	transition: all 0.3s;
	color: rgba(255, 255, 255, 0.85);
}

.toggle-btn:hover {
	background: rgba(255, 255, 255, 0.15);
	color: #fff;
}

.toggle-btn i {
	font-size: 18px;
}

.header-right {
	display: flex;
	align-items: center;
}

.distributor-select {
	width: 180px;
	margin-right: 16px;
}

.distributor-select >>> .el-input__inner {
	background: rgba(255, 255, 255, 0.15);
	border: 1px solid rgba(255, 255, 255, 0.3);
	color: #fff;
}

.distributor-select >>> .el-input__inner::placeholder {
	color: rgba(255, 255, 255, 0.7);
}

.distributor-select >>> .el-select__caret {
	color: rgba(255, 255, 255, 0.7);
}

.header-actions {
	display: flex;
	align-items: center;
}

.action-item {
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 8px;
	transition: all 0.3s;
	color: rgba(255, 255, 255, 0.85);
	margin-right: 8px;
}

.action-item:hover {
	background: rgba(255, 255, 255, 0.15);
	color: #fff;
}

.action-item i {
	font-size: 18px;
}

.user-dropdown {
	margin-left: 8px;
}

.user-info {
	display: flex;
	align-items: center;
	cursor: pointer;
	padding: 6px 12px;
	border-radius: 8px;
	transition: all 0.3s;
}

.user-info:hover {
	background: rgba(255, 255, 255, 0.15);
}

.avatar {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: 2px solid rgba(255, 255, 255, 0.5);
}

.username {
	margin: 0 8px;
	color: #fff;
	font-size: 14px;
}

.user-info .el-icon-arrow-down {
	color: rgba(255, 255, 255, 0.7);
	font-size: 12px;
}

.main-container {
	margin-top: 56px;
	height: calc(100vh - 56px);
}

.aside {
	background: #fff;
	box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
	transition: width 0.3s;
	position: relative;
	z-index: 100;
}

.aside-scrollbar {
	height: 100%;
}

.aside-menu {
	border-right: none;
	height: 100%;
}

.aside-menu >>> .el-menu-item,
.aside-menu >>> .el-submenu__title {
	height: 48px;
	line-height: 48px;
	margin: 4px 8px;
	border-radius: 8px;
}

.aside-menu >>> .el-menu-item:hover,
.aside-menu >>> .el-submenu__title:hover {
	background: #f5f7fa;
}

/* 菜单选中样式 */
.aside-menu >>> .el-menu-item.is-active {
	background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%) !important;
	color: #fff !important;
}

.aside-menu >>> .el-menu-item.is-active i {
	color: #fff !important;
}

.aside-menu >>> .el-submenu .el-menu-item {
	padding-left: 52px !important;
}

.aside-menu >>> .el-menu-item i,
.aside-menu >>> .el-submenu__title i {
	margin-right: 12px;
	color: #595959;
	font-size: 16px;
}

.main-content {
	background: #f0f2f5;
	padding: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.page-wrapper {
	flex: 1;
	padding: 9px;
	overflow-y: auto;
}

.page-content {
	background: #fff;
	border-radius: 8px;
	min-height: calc(100% - 32px);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.fade-transform-enter-active,
.fade-transform-leave-active {
	transition: all 0.3s;
}

.fade-transform-enter,
.fade-transform-leave-to {
	opacity: 0;
	transform: translateX(-10px);
}
</style>

<style>
.user-dropdown-menu {
	margin-top: 8px;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.user-dropdown-menu .el-dropdown-menu__item {
	padding: 10px 20px;
}

.user-dropdown-menu .el-dropdown-menu__item i {
	margin-right: 8px;
}
</style>
